module.exports = __webpack_public_path__ + "img/icon-user.10740f8b.svg";